import { AccordionEnhancedItem } from '@ahc-digital/component-library';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { CreateC36AccordionEnhancedModel } from './C36AccordionEnhancedItem.service';
import { C36AccordionEnhancedItemProps } from './C36AccordionEnhancedItem.types';
import { useCreateMarketingRenderingHame } from '@/shared/useCreateMarketingRenderingName';
import { useCustomSitecoreContext } from '@/shared/useCustomSitecoreContext';
import { PromptForUnavailableInTheme } from '@/shared/PromptForUnavailableInTheme';

const Default = (props?: C36AccordionEnhancedItemProps) => {
  const { rendering } = props || {};

  const marketingRenderingName = useCreateMarketingRenderingHame(
    rendering?.componentName as string
  );
  const context = useCustomSitecoreContext();

  if (context?.siteTheme?.value !== 'WakeForest')
    return (
      <PromptForUnavailableInTheme
        siteTheme={context?.siteTheme?.value ?? ''}
        componentName={rendering?.componentName}
      />
    );

  return (
    <AccordionEnhancedItem
      value={rendering?.uid || ''}
      data-component={marketingRenderingName}
      {...CreateC36AccordionEnhancedModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C36AccordionEnhancedItemProps>(Default);
